// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__X4n3L","head":"Table_head__1SSI_","col":"Table_col__1fw0R"};